import { createAction, props } from '@ngrx/store';
import { IAddressData, IAddressModel } from '@partners/api';

export class AddressActions {
  static reset = createAction('[Address] Reset State');
  static updateModel = createAction('[Address] Update Model', props<{ model: IAddressModel }>());
  static load = createAction('[Address] Load');
  static loadSuccess = createAction('[Address] Load Success', props<{ model: IAddressModel; data: IAddressData }>());
  static loadFailure = createAction('[Address] Load Failure', props<{ error: any }>());
  static submit = createAction('[Address] Submit');
  static submitSuccess = createAction(
    '[Address] Submit Success',
    props<{ model: IAddressModel; data: IAddressData }>()
  );
  static submitFailure = createAction('[Address] Submit Failure', props<{ error: any }>());
}
